var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30950_153489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6654 2.16675H4.9987C4.08203 2.16675 3.33203 2.91675 3.33203 3.83341V17.1667C3.33203 18.0834 4.08203 18.8334 4.9987 18.8334H14.9987C15.9154 18.8334 16.6654 18.0834 16.6654 17.1667V7.16675L11.6654 2.16675ZM4.9987 17.1667V3.83341H10.832V7.16675H14.9987V17.1667H4.9987ZM9.16536 16.3334H10.832V15.5001H11.6654C12.1237 15.5001 12.4987 15.1251 12.4987 14.6667V12.1667C12.4987 11.7084 12.1237 11.3334 11.6654 11.3334H9.16536V10.5001H12.4987V8.83342H10.832V8.00008H9.16536V8.83342H8.33203C7.8737 8.83342 7.4987 9.20842 7.4987 9.66675V12.1667C7.4987 12.6251 7.8737 13.0001 8.33203 13.0001H10.832V13.8334H7.4987V15.5001H9.16536V16.3334Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30950_153489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestQuote);
export default __webpack_public_path__ + "static/media/request_quote.5a4e356118fc0701b6cd78d2cbf66de3.svg";
export { ForwardRef as ReactComponent };